import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpBackend } from '@angular/common/http';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { apiRoutes, statusCodes, cUserStates } from '../constants/constants';
import { NotificationService } from '../services/notification.service';
import { iLogin, iAuth, iResponse } from '../interfaces/interfaces';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private isAuthenticated = false;
  private authData: iAuth = this.createObj();
  private token: string;
  private authStatusListener = new Subject<boolean>();
  private arrMenu: any;
  private rolId: any;
  private cajaPuntoVentaId: any;
  private arrRol: any[];
  private arrCaja: any[];

  private http: HttpClient;
  constructor(private handler: HttpBackend, private notificationService: NotificationService, private router: Router) {
    this.http = new HttpClient(handler)
  }

  getAuthData() {
    this.authData = JSON.parse(localStorage.getItem('authData'));
    return this.authData;
  }

  createObj() {
    return { token: null, usuario: null, accesos: null, menu: null, config: null };
  }

  getToken() {
    let authData = this.getAuthData();
    this.token = authData ? authData.token : null;
    return this.token;
  }

  setToken(newToken: string)
  {
    let authData = this.getAuthData();
    authData.token = newToken; 
    this.token = newToken;
    this.authData = authData;
    localStorage.setItem('authData', JSON.stringify(this.authData));
  }

  getIsAuth() {
    return this.isAuthenticated;
  }

  getAuthStatusListener() {
    return this.authStatusListener.asObservable();
  }

  getMenu() {
    return this.arrMenu;
  }

  getAuthenticated() {
    return this.getToken() != null;
  }

  login(loginData: iLogin) {
    return new Promise((resolve, reject) => {
      this.http.post(apiRoutes.ROUTE_LOGIN, loginData).subscribe(
        (response: iResponse) => {
          console.log("response", response);
          this.authData = this.createObj();
          const { codigo, data } = response;
          this.authData = data;
          if (codigo === statusCodes.ok.code && this.authData.usuario.estadoId == cUserStates.creado) {
            this.notificationService.success('Ingresa una nueva contraseña');
            this.loginPassword(response);
          } else if (codigo === statusCodes.ok.code && this.authData.usuario.estadoId == cUserStates.habilitado) {
            this.notificationService.success(`Bienvenido, ${this.authData.usuario.nombre}`);
            this.loginSuccess();
          } else {
            this.notificationService.error('Hubo un problema al actualizar');
          }
          resolve(response);
        },
        (error: any) => {
          if (error && error.error) this.notificationService.verifyStatus(error.error, true);
          reject();
        });
    });
  }

  notificationError(response: any) {
    const operation = response.error;
    this.notificationService.verifyStatus(operation);
  }

  existEmail(email: string) {
    return new Promise((resolve, reject) => {
      this.http.get(apiRoutes.ROUTE_EXISTEMAIL + `?email=${email}`).subscribe(
        (response: any) => {
          resolve(response);
        },
        (error: any) => {
          this.notificationService.error(error);
          reject();
        });
    });
  }

  register(objRegister: any) {
    return new Promise((resolve, reject) => {
      this.http.post(apiRoutes.ROUTE_REGISTER, objRegister).subscribe(
        (response: any) => {
          let success = this.notificationService.verifyStatus(response, false);
          resolve(success);
        },
        (error: any) => {
          this.notificationService.error(error);
          reject();
        });
    });
  }

  forgotPassword(email: string) {
    return new Promise((resolve, reject) => {
      this.http.post(apiRoutes.ROUTE_FORGOTPASSWORD, { email: email }).subscribe(
        (response: any) => {
          let success = this.notificationService.verifyStatus(response, false);
          if (success) this.notificationService.success(`Se enviado un correo electrónico para restablecer la contraseña, con el cual sera redirigido a la página restablecer contraseña`);
          resolve(response);
        },
        (error: any) => {
          this.notificationService.error(error);
          reject();
        });
    });
  }

  verifyChangePassword(token: string) {
    return new Promise((resolve, reject) => {
      this.http.post(apiRoutes.ROUTE_VERIFYTOKEN_FP, { token: token }).subscribe(
        (response: any) => {
          let success = this.notificationService.verifyStatus(response, false);
          if (!success) {
            this.notificationService.error(`Este solicitud ya ha expirado!`);
            setTimeout(() => {
              this.router.navigate(['error']);
            }, 6000);
          }
          resolve(response);
        },
        (error: any) => {
          this.notificationService.error(error);
          reject();
        });
    });
  }

  resetPassword(token: string, password: string) {
    return new Promise((resolve, reject) => {
      this.http.post(apiRoutes.ROUTE_RESET_PASSWORD, { token: token, password: password }).subscribe(
        (response: any) => {
          let success = this.notificationService.verifyStatus(response, true);
          if (success) {
            setTimeout(() => {
              this.router.navigate(['user/login']);
            }, 2000);
          }
          resolve(response);
        },
        (error: any) => {
          this.notificationService.error(error);
          reject();
        });
    });
  }

  resetLoginPassword(token: string, password: string) {
    return new Promise((resolve, reject) => {
      let headers = new HttpHeaders();
      headers = headers.set('Authorization', 'Bearer ' + token)
      this.http.post(apiRoutes.ROUTE_RESET_LOGIN_PASSWORD,
        { passwordNueva: password }, { headers: headers }
      ).subscribe(
        (response: any) => {
          let success = this.notificationService.verifyStatus(response, true);
          if (success) {
            setTimeout(() => {
              this.router.navigate(['auth/login']);
            }, 2000);
          }
          resolve(response);
        },
        (error: any) => {
          this.notificationService.error(error);
          reject();
        });
    });
  }

  loginPassword(response: any) {
    const token = response.data.token;
    this.token = token;
    if (token) {
      this.router.navigate(['auth/reset'], { queryParams: { token: token } });
    }
  }

  loginSuccess() {
    if (this.authData.token) {
      this.isAuthenticated = true;
      this.authStatusListener.next(true);
      localStorage.setItem('home', '/app'); //this.authData.home
      localStorage.setItem('authData', JSON.stringify(this.authData));
      this.router.navigate(['/app']);
    }
  }

  returnHome() {
    this.router.navigate(['/app/start']);
  }

  ValidarSession() {
    return this.http.get<{ token: string; }>(
      'http://localhost:3000/login'
    );
  }

  autoAuthUser() {
    const authInformation = this.getAuthData();
    if (!authInformation) {
      return;
    }
    this.token = authInformation.token;
    this.isAuthenticated = true;
    this.authStatusListener.next(true);
  }

  logout() {
    this.token = null;
    this.isAuthenticated = false;
    this.authStatusListener.next(false);
    localStorage.removeItem('authData');
    localStorage.removeItem('studentData');
    this.router.navigate(['auth/login']);
  }

  private saveAuthData(token: string) {
    /*
    localStorage.setItem('token', token);
    localStorage.setItem('user', this.user);
    localStorage.setItem('fotografia', this.nameUser);
    localStorage.setItem('fotografia', this.fotografia);
    */
  }

  private clearAuthData() {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('nameUser');
  }

  getMenuData() {
    let authData = this.getAuthData();
    this.arrMenu = this.createMenu(authData.menu.submenus);
    return this.arrMenu;
  }

  getLogo() {
    this.authData = this.getAuthData();
    return this.authData.config.logoOrganizacion;
  }

  createMenu(lstMenu: any[]) {
    let lstResult = [];
    for (const menu of lstMenu) {
      let objMenu = { id: menu.menuId, icon: menu.icon, label: menu.nombre, to: menu.ruta };
      if (menu.hijos && menu.hijos.length > 0) objMenu["subs"] = this.createMenu(menu.hijos);
      lstResult.push(objMenu);
    }
    return lstResult;
  }

  private clearMenuData() {
    localStorage.removeItem('menu');
  }

  private getObjToken() {
    const token = localStorage.getItem('token');
    if (!token) {
      return;
    }
    return {
      token: token
    };
  }

  getRolId() {
    const authDataString = localStorage.getItem('authData');
    const authObj: iAuth = JSON.parse(authDataString);
    this.rolId = authObj.accesos.rolSeleccionado;
    return this.rolId;
  }

  getArrRol() {
    const authDataString = localStorage.getItem('authData');
    const authObj: iAuth = JSON.parse(authDataString);
    this.arrRol = authObj.accesos.roles;
    return this.arrRol;
  }

  setCambioRol(response: any) {
    this.authData = this.createObj();
    this.authData = response;
    this.loginSuccess();
    window.location.reload();
  }
}
